import { render, staticRenderFns } from "./GPagination.vue?vue&type=template&id=121186f0&"
import script from "./GPagination.vue?vue&type=script&lang=js&"
export * from "./GPagination.vue?vue&type=script&lang=js&"
import style0 from "./GPagination.vue?vue&type=style&index=0&id=121186f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports